/**
 * "Note something not on paper" (docs/19 A3, part 4) — rare, and one line: a
 * date promised in a meeting, a query written in a margin. It moves nothing on
 * the case; it is kept on the case file page with who noted it and when.
 */

import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { api } from '../../api/client'
import type { CaseDetail } from '../../api/client'
import { ErrorEnvelope } from '../../components/bits'
import { useRefreshCase } from './acting'

/** The server's own cap; the field stops there rather than failing at the post. */
const ONE_LINE = 300

export function NoteLine({ data }: { data: CaseDetail }) {
  const refresh = useRefreshCase(data.id)
  const [text, setText] = useState('')
  const [on, setOn] = useState(data.as_of)
  const note = useMutation({
    mutationFn: () =>
      api.recordNote(data.id, { preflight: false, text: text.trim(), noted_on: on }),
    onSuccess: () => {
      setText('')
      refresh()
    },
  })
  return (
    <section className="note-line" data-testid="note-line">
      <h3>Note something not on paper</h3>
      <div className="na-form">
        <input
          aria-label="One line"
          placeholder="One line — a date promised in a meeting, a query in a margin"
          maxLength={ONE_LINE}
          value={text}
          onChange={(event) => setText(event.target.value.replace(/[\r\n]+/g, ' '))}
          data-testid="note-text"
        />
        <label className="na-date">
          Said on
          <input
            type="date"
            aria-label="Said on"
            value={on}
            onChange={(e) => setOn(e.target.value)}
          />
        </label>
        <button
          type="button"
          disabled={!text.trim() || !on || note.isPending}
          onClick={() => note.mutate()}
          data-testid="record-note"
        >
          {note.isPending ? 'Noting…' : 'Note it'}
        </button>
      </div>
      <ErrorEnvelope error={note.error} />
    </section>
  )
}
